<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    >
      <div slot="driverLicenseExpired" slot-scope="prop">
        <el-checkbox label="即将过期" name="type" v-model="prop.form.driverLicenseExpired" />
      </div>
      <section slot="position" slot-scope="prop">
        <ChooseAddress :showCloseBtn="true" :showCleanBtn="true" v-model="prop.form.position" />
      </section>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import ChooseAddress from 'components/chooseAddress/chooseAddress';
import TableBox from './tableBox';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
    ChooseAddress,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        trailerMaterialOptions: [],
        isStateOptions: [],
        vehicleClassOptions: [],
        form: [
          {
            label: '',
            value: 'auditState',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
            options: [
              { label: '全部', value: -1 },
              { label: '待审核', value: '0' },
              { label: '审核通过', value: '1' },
              { label: '已驳回', value: '2' },
            ],
          },
          {
            label: '车牌号码',
            value: 'trailerNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '使用状态',
            value: 'useState',
            type: 'select',
            default: '-1',
            placeholder: '请选择使用状态',
            options: [{
              label: '请选择',
              value: '-1',
            }, {
              label: '在用',
              value: '1',
            }, {
              label: '闲置',
              value: '0',
            }],
          },
          {
            label: '起始位置',
            value: 'position',
            slot: true,
            default: [],
          },
          {
            label: '当前状态',
            value: 'isState',
            type: 'select',
            placeholder: '请选择状态',
          },
          // {
          //   label: '归属部门',
          //   value: 'orgId',
          //   type: 'select',
          //   default: '-1',
          // },
          {
            label: '挂车材质',
            value: 'trailerMaterial',
            type: 'select',
            default: '-1',
          },
          {
            label: '挂车种类',
            value: 'vehicleClass',
            type: 'select',
            default: '-1',
          },
          {
            label: '行驶证',
            value: 'driverLicenseExpired',
            default: false,
            slot: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.position.length) {
        searchBoxData.sourceProvince = searchBoxData.position[0]; // 省
        searchBoxData.sourceRegion = searchBoxData.position[1]; // 市
        searchBoxData.sourceCounty = searchBoxData.position[2]; // 区
      }
      delete searchBoxData.position;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'TRAILER_MATERIAL,TRAILER_TYPE,TRAILER_VEHICLE_CLASS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.trailerMaterialOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.isStateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(1),
    ];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(2),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...(await getDepartmentAllList() || []),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
